import React, { Component } from 'react';
import * as d3 from "d3";
import cipher from '../images/cipher.png';


class ProgressCircleWrapper extends Component {

    constructor(props) {
      super(props);
    };

  render() {
    let valorGraph = 0, valorGraphClass = "06";
    const svgHeight = this.props.svgWidth;
    const arcOuterRadius = this.props.svgWidth / 2;
    const arcInnerRadius = this.props.svgWidth / 2 - this.props.arcWidth;
    const arcGenerator = d3
      .arc()
      .innerRadius(arcInnerRadius)
      .outerRadius(arcOuterRadius)
      .startAngle(0)
      .cornerRadius(5);
    const progressArc = value =>
      arcGenerator({
        endAngle: 2 * Math.PI * value
      });

      if((this.props.progressPercentage >= 0)&&(this.props.progressPercentage <= 14))
        {valorGraph = 0;}
      else if((this.props.progressPercentage >= 15)&&(this.props.progressPercentage <= 28))
       {valorGraph = 0.1;}
      else if((this.props.progressPercentage >= 29)&&(this.props.progressPercentage <= 42))
       {valorGraph = 0.2;}
      else if((this.props.progressPercentage >= 43)&&(this.props.progressPercentage <= 56))
        {valorGraph = 0.3;}
      else if((this.props.progressPercentage >= 57)&&(this.props.progressPercentage <= 70))
        {valorGraph = 0.4;}
      else if((this.props.progressPercentage >= 71)&&(this.props.progressPercentage <= 84))
        {valorGraph = 0.5;}
      else if(this.props.progressPercentage >= 85)
        {valorGraph = 0.6;}
    
    return (
      <div className="graph-program">
        <svg height={svgHeight} width={this.props.svgWidth}>
          <g transform={`translate(${this.props.svgWidth / 2}, ${svgHeight / 2})`}>
            <path d={progressArc(0.6)} opacity="0.2" fill="gray" />
          </g>
          <g transform={`translate(${this.props.svgWidth / 2}, ${svgHeight / 2})`}>
            <path
              d={progressArc(valorGraph)}
              // Só vai até 0.6
              fill={"#2649AF"}
            />
          </g>
        </svg>
        <img className={`cipher_menu position${valorGraphClass}`} src={cipher} />
      </div>

    )
  }

  
}

export default ProgressCircleWrapper; // Don’t forget to use export default!